import React from 'react'
import {
  Wrap,
  ColLeft,
  ColRight,
  LargeColLeft,
  LargeColRight,
  FullCentered,
  spacedVertical,
} from '@/styles/Layout'
import Logo from '@/components/Featured/Mundial62/Logo'
import PostMeta from '@/components/Featured/Mundial62/Posts/PostMeta'
import styled from 'styled-components'
import PostImage from './PostImage'
import PostFormattedTitle from './PostFormattedTitle'
import PostExcerpt from './PostExcerpt'

const PostWrap = styled(Wrap)`
  ${spacedVertical}
`

const PostHeader = ({
  title,
  pretitle,
  posttitle,
  largesttitle,
  layout = 'base',
  author,
  authorsite,
  authorsiteurl,
  date,
  slug,
  featuredImage,
  excerpt,
  withPostImage = true,
}) => {
  if (layout === 'large') {
    return (
      <PostWrap as="header" className={withPostImage ? '' : 'pt-4'}>
        {withPostImage && (
          <FullCentered>
            <PostImage image={featuredImage} />
          </FullCentered>
        )}
        <LargeColLeft className="items-start justify-end hidden sm:flex">
          <Logo alignment="right" className="mt-12 max-h-36 " />
        </LargeColLeft>
        <LargeColRight>
          <PostFormattedTitle
            title={title}
            pretitle={pretitle}
            posttitle={posttitle}
            largesttitle={largesttitle}
          />
          <PostExcerpt excerpt={excerpt} />

          <PostMeta
            date={date}
            author={author}
            authorsite={authorsite}
            authorsiteurl={authorsiteurl}
            slug={slug}
          />
        </LargeColRight>
      </PostWrap>
    )
  }

  return (
    <PostWrap as="header">
      {withPostImage && (
        <FullCentered>
          <PostImage image={featuredImage} />
        </FullCentered>
      )}

      <ColLeft className="items-start justify-end hidden sm:flex">
        <Logo alignment="right" className="mt-12 max-h-36" />
      </ColLeft>
      <ColRight>
        <PostFormattedTitle
          title={title}
          pretitle={pretitle}
          posttitle={posttitle}
          largesttitle={largesttitle}
        />
        <PostExcerpt excerpt={excerpt} />

        <PostMeta
          date={date}
          author={author}
          authorsite={authorsite}
          authorsiteurl={authorsiteurl}
          slug={slug}
        />
      </ColRight>
    </PostWrap>
  )
}

export default PostHeader
